"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This package is deprecated.
// All exports here are just for backward compatibility.
// Please use type from their real packages directly
var ImageResize_1 = require("roosterjs-editor-plugins/lib/ImageResize");
exports.ImageResize = ImageResize_1.ImageResize;
//# sourceMappingURL=index.js.map